export default {
  data: () => ({
    observedVisibility: false,
    observedEntry: null,
  }),

  methods: {
    checkVisibility(callback) {
      this.$nextTick(() => {
        if (this.observedVisibility === true) {
          callback(this.observedVisibility, this.observedEntry, {
            cache: true,
          });
        }
      });
    },
    handleVisibilityChanged(isVisible, entry, extra) {
      if (extra && extra.cache === true) return false;
      this.observedVisibility = isVisible;
      this.observedEntry = entry;
      return isVisible;
    },
  },
};
